import DeploymentGrid from "../deployments/Index";

type Props = {};

const Index = (props: Props) => {
  return <DeploymentGrid />;
};

export default Index;
